module.exports = __webpack_public_path__ + "img/down-arrow.0539b16b.svg";